import Column from 'components/Column';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 48px 32px;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 700px) {
    padding: 24px 16px;
  }
`;

export const ColumnImages = styled(Column)`
  min-width: 400px;

  @media (max-width: 700px) {
    min-width: auto;
  }
`;

export const MainImageWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  cursor: zoom-in;
  background: ${({ theme }) => theme.colors.concrete};

  &:hover > span {
    opacity: 1;
  }
`;

export const ZoomHint = styled.span`
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
`;

export const MainImage = styled.img`
  width: 100%;
  max-height: 520px;
  object-fit: contain;
  display: block;
`;

export const ThumbnailStrip = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

export const Thumbnail = styled.img<{ $selected: boolean }>`
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid
    ${({ theme, $selected }) => ($selected ? theme.colors.gulfStream : 'transparent')};
  opacity: ${({ $selected }) => ($selected ? 1 : 0.65)};
  transition:
    opacity 0.15s,
    border-color 0.15s;

  &:hover {
    opacity: 1;
  }
`;

export const LightboxOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LightboxImg = styled(motion.img)`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
  user-select: none;
`;

export const LightboxClose = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.12);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

export const LightboxNavBtn = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => $side}: 20px;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.12);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: rgba(255, 255, 255, 0.25);
  }

  @media (max-width: 700px) {
    width: 36px;
    height: 36px;
    ${({ $side }) => $side}: 8px;
  }
`;

export const Content = styled.div`
  padding-left: 40px;

  @media (max-width: 700px) {
    padding: 16px 0 0;
  }
`;

export const Title = styled.div`
  font-size: 30px;
  line-height: 1.2;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.shaft};
`;

export const Price = styled.div`
  font-size: 18px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.gulfStream};
  margin-top: 4px;
`;

export const Description = styled.div`
  font-size: 15px;
  line-height: 1.6;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.gray};
`;
